"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Aug 20 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * TableLineProductConverter.
 *
 * @author RV
 */


var SettingsOverviewDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SettingsOverviewDTOConverter, _DataObjectConverter_);

  function SettingsOverviewDTOConverter() {
    _classCallCheck(this, SettingsOverviewDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SettingsOverviewDTOConverter).apply(this, arguments));
  }

  return SettingsOverviewDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SettingsOverviewDTOConverter = SettingsOverviewDTOConverter;